import { render, staticRenderFns } from "./HKLCard.vue?vue&type=template&id=003054ac&scoped=true&"
import script from "./HKLCard.vue?vue&type=script&lang=js&"
export * from "./HKLCard.vue?vue&type=script&lang=js&"
import style0 from "./HKLCard.vue?vue&type=style&index=0&id=003054ac&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "003054ac",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/runner/work/PMS_Client/PMS_Client/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('003054ac')) {
      api.createRecord('003054ac', component.options)
    } else {
      api.reload('003054ac', component.options)
    }
    module.hot.accept("./HKLCard.vue?vue&type=template&id=003054ac&scoped=true&", function () {
      api.rerender('003054ac', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/controls/Card/HKLCard.vue"
export default component.exports